import { createElement, Fragment, type ReactNode } from "react";
import { type StaticImageData } from "next/image";

import arnoldSignatureImage from "@assets/images/creators/arnold-signature.avif";
import jeffersonImage from "@assets/images/creators/jefferson.avif";
import liftUpTheWorldImage from "@assets/images/creators/lift-up-the-world-transparent.avif";
import shaneParrishImage from "@assets/images/creators/shane-parrish.avif";
import timFerrissImage from "@assets/images/creators/tim-ferriss.avif";

type CreatorPopupImage = {
  src: StaticImageData;
  alt: string;
};

export type CreatorPopup = {
  image: CreatorPopupImage;
  callout?: string;
  quote?: ReactNode;
  signatureImage?: CreatorPopupImage;
  firstName: string;
  lastName?: string;
  rewardLine: string;
};

export const CREATOR_POPUPS: Record<string, CreatorPopup> = {
  PUMPCLUB: {
    image: {
      src: liftUpTheWorldImage,
      alt: "Arnold's Pump Club Lift Up The World",
    },
    quote: createElement(
      Fragment,
      null,
      "\"Your floors are either helping your nervous system recover or working against it. There's no neutral. The fix isn't more effort. It's removing the effort entirely. ",
      createElement("span", { className: "font-semibold" }, "That's Matic"),
      '."',
    ),
    signatureImage: {
      src: arnoldSignatureImage,
      alt: "Arnold",
    },
    firstName: "THE APC",
    rewardLine: "You unlocked the APC Reward!",
  },
  TIMFERRISS: {
    image: {
      src: timFerrissImage,
      alt: "Tim Ferriss",
    },
    callout: "Tim trusts Matic.",
    quote:
      '"I’ve been testing Matic myself, and it’s the closest thing to a house that cleans itself. My friends have been raving about theirs, and now I understand why."',
    firstName: "Tim",
    lastName: "Ferriss",
    rewardLine: "You unlocked Tim's reward!",
  },
  JEFFERSON: {
    image: {
      src: jeffersonImage,
      alt: "Jefferson",
    },
    callout: "Jefferson trusts Matic.",
    quote: '"It’s going to change your life, and make cleaning manageable."',
    firstName: "Jefferson",
    rewardLine: "You unlocked Jefferson's reward!",
  },
  SHANEPARRISH: {
    image: {
      src: shaneParrishImage,
      alt: "Shane Parrish",
    },
    callout: "Shane trusts Matic.",
    quote:
      '"Matic is super easy to schedule. I have it run every night and wake up to clean floors."',
    firstName: "Shane",
    lastName: "Parrish",
    rewardLine: "You unlocked Shane's reward!",
  },
};

export const getCreatorPopup = (code: string): CreatorPopup | null => {
  const bareCode = code.toUpperCase().replace(/^FRIEND-/, "");
  return CREATOR_POPUPS[bareCode] ?? null;
};
